import {mapGetters} from 'vuex';

/**
 * Helper condivisi per gestire i tornei di tipo Individuale (contestType === 3),
 * dove la fonte di verità è l'id giocatore (individualPlayerId / Inorth,Isouth,Ieast,Iwest)
 * e non l'id di coppia (pairId / NSex,EWex). Per i tornei a coppie/squadre i predicati
 * ricadono sul comportamento storico basato su pairId.
 */
export default {
    computed: {
        ...mapGetters({
            contestType: 'tournament/contestType',
            pairId: 'tournament/pairId',
            individualPlayerId: 'tournament/individualPlayerId',
            playersList: 'players/playersList'
        }),
        isIndividual() {
            return this.contestType === 3;
        },
        playerRankId() {
            return this.isIndividual ? this.individualPlayerId : this.pairId;
        },
        playersByCode() {
            return Object.values(this.playersList)
                .reduce((acc, pl) => { if (pl.Code) acc[pl.Code] = pl; return acc; }, {});
        }
    },
    methods: {
        isOurScore(score) {
            if (this.isIndividual) {
                return [score.Inorth, score.Isouth, score.Ieast, score.Iwest].includes(this.individualPlayerId);
            }

            return [score.NSex, score.EWex].includes(this.pairId);
        },
        isOurNsSide(score) {
            if (this.isIndividual) {
                return [score.Inorth, score.Isouth].includes(this.individualPlayerId);
            }

            return score.NSex === this.pairId;
        },
        isOurEwSide(score) {
            if (this.isIndividual) {
                return [score.Ieast, score.Iwest].includes(this.individualPlayerId);
            }

            return score.EWex === this.pairId;
        }
    }
};
